import React from 'react'
import './contentDetail.css'
import Countdown from 'react-countdown'
import FlipClock from './flipCounter'
import { useTranslation } from 'react-i18next'

const LiveCounter = (props) => {
  const { t } = useTranslation()
  const {
    contentDetail,
    handleCompletion,
    styles = { top: '70%', left: '60%' },
    counterClass = '',
    removeText = false,
  } = props
  return (
    <div className={`z-10 xl:absolute py-5 ${counterClass}`} style={styles}>
      {!removeText && (
        <p className={'text-white text-md md:text-3xl text-center mb-2'}>{t('going_live_in')}</p>
      )}

      <Countdown
        date={new Date(contentDetail.publish_time + 'Z').getTime()}
        onComplete={handleCompletion}
        renderer={({ days, hours, minutes, seconds, completed }) => (
          <FlipClock
            days={days}
            hours={hours}
            minutes={minutes}
            seconds={seconds}
            completed={completed}
          />
        )}
      />
    </div>
  )
}

export default LiveCounter
